import { boot } from 'quasar/wrappers'
import { copyToClipboard } from "quasar";

export default boot(({ app }) => {
    app.config.globalProperties.$copyToClipboard = copyToClipboard
});